module.exports = __webpack_public_path__ + "front/img/info_btn.b230c9a1.png";